module.exports = __webpack_public_path__ + "e15907e6f5412a43f6150602676f5aaa.png";